'use client';

import React from 'react';
import cn from 'classnames';
import { usePathname } from '@framework/next/navigation';
import Header from '@framework/ui/Pages/Landing/Legacy/Sections/Header';
import CookiesBanner from '@framework/cookie-consent/CookiesBanner';
import useLoginUrlWithConsent from '@framework/cookie-consent/useLoginUrlWithConsent';
import Footer from './Footer';
import BookDemoButton from '@/dataroom/ui/common/BookDemoButton';
import config from '@/dataroom/app/config/config';
import DataroomTenantContext from '@dataroom/tenant/DataroomTenantContext';
import ScrollBodyBackground from '@framework/ui/Templates/ScrollBodyBackground';
import stickyFooterStyles from '@framework/ui/Organisms/StickyFooter/stickyFooter.module.scss';
import headerStyles from '@framework/ui/Pages/Landing/Legacy/Sections/Header/header.module.scss';
import styles from './tenantVeriSend.module.scss';
import logo from '@/dataroom/ui/assets/veriSendLogoText.svg';
import dataroomUrl from '@/dataroom/infrastructure/dataroomUrl';
import dmPortalUrl from '@dm-portal/url';

interface IProps {
  children: React.ReactNode,
}

const TenantVeriSend = ({ children }: IProps) => {
  const tenant = config.tenant.tenantVeriSend.code;
  const pathname = usePathname();

  const loginUrl = useLoginUrlWithConsent(() =>
    dataroomUrl(tenant).getLoginUrl(dmPortalUrl.getUrl(`/${ tenant }`)),
  );

  const registerUrl = dataroomUrl(tenant).getRegisterUrl(
    dataroomUrl(tenant).getUrl(pathname),
  );

  return (
    <DataroomTenantContext tenant={ tenant }>
      <Header
        tenant={ tenant }
        logo={ logo.src }
        menu={ [] }
        button={ () => (
          <BookDemoButton legacy className={ headerStyles.menuBtn } />
        ) }
        loginUrl={ loginUrl }
        registerUrl={ registerUrl }
      />
      <div className={ cn(styles.pageContainer, stickyFooterStyles.pageContainerWithStickyFooter) }>
        <ScrollBodyBackground tenant={ tenant } />
        { children }
      </div>
      <Footer tenant={ tenant } />
      <CookiesBanner />
    </DataroomTenantContext>
  );
};

export default TenantVeriSend;
